import { colors } from "../../utils/colors";
import { SxProps } from "@mui/material";

export const FinancialExportStyles = {
  filterSection: {
    width: "auto",
    height: "auto",
    backgroundColor: colors.white,
    boxShadow: `0px 0px 4px 0px ${colors.shadow_black}`,
    borderRadius: "0.5rem",
    padding: "1.25rem",
  },
  filterBoxes: {
    display: "flex",
    flexDirection: "row",
    flexWrap: "wrap",
    justifyContent: "center",
    alignItems: "flex-start",
    gap: "1.5rem",
    width: "100%",
    "@media (max-width: 768px)": {
      flexDirection: "column",
      alignItems: "stretch",
    },
  },
  filterGrid: {
    display: "flex",
    flexDirection: "row",
    flexWrap: "wrap",
    gap: "1.5rem",
    alignItems: "flex-start",
    justifyContent: "center",
    flex: "1 1 auto",
    minWidth: 0,
    maxWidth: "100%",
    "@media (max-width: 768px)": {
      flexDirection: "column",
      width: "100%",
      flexWrap: "nowrap",
    },
  },
  filterInputWidth: {
    flex: "1 1 14rem",
    minWidth: "12rem",
    maxWidth: "18.75rem",
    width: "100%",
    "@media (max-width: 1200px)": {
      flex: "1 1 13rem",
      maxWidth: "16rem",
    },
    "@media (max-width: 1000px)": {
      flex: "1 1 12rem",
      maxWidth: "14rem",
    },
    "@media (max-width: 768px)": {
      width: "100%",
      minWidth: "100%",
      maxWidth: "100%",
      flex: "1 1 100%",
    },
  },
  filterButtonBox: {
    display: "flex",
    alignItems: "flex-end",
    flexShrink: 0,
    alignSelf: "flex-end",
    paddingTop: "1.43rem",
    paddingBottom: "0.25rem",
    gap: "1rem",
    "@media (max-width: 1200px)": {
      alignSelf: "center",
    },
    "@media (max-width: 768px)": {
      width: "100%",
      justifyContent: "center",
      alignItems: "center",
      alignSelf: "center",
      paddingTop: "0",
      paddingBottom: "0",
    },
  },
  filterButton: {
    width: "7rem",
    height: "2.4375rem",
    minWidth: "7rem",
  },
  datePickerLabel: {
    fontSize: "0.75rem",
    fontWeight: 400,
    color: colors.grayish_blue,
    mb: "0.25rem",
  },
  calendarIconWrapper: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "1.75rem",
    height: "1.75rem",
    borderRadius: "50%",
    cursor: "pointer",
    transition: "background-color 0.2s ease",
    "&:hover": {
      backgroundColor: colors.hover_gray,
    },
  },
  calendarMonthIcon: {
    color: colors.grayish_blue,
    width: "1rem",
    height: "1rem",
  },
  inputPropsStyle: {
    fontSize: "0.875rem",
    color: colors.grayish_blue,
    height: "2.5rem",
  },

  inputBaseStyle: {
    fontSize: "0.875rem",
    color: colors.grayish_blue,
  },

  tableContainer: {
    overflowY: "auto",
    overflowX: "auto",
    backgroundColor: colors.white,
    width: `100%`,
    height: `56vh`,
    position: "relative",
    elevation: 0,
    boxShadow: "none",
    borderRadius: "0.5rem",
  },
  tableHeader: {
    py: "1.0rem",
  },
  statusCell: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },
  refreshButton: {
    backgroundColor: colors.white,
    borderRadius: "0.25rem",
    height: "2rem",
    width: "3.5rem",
    px: "0.5rem",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    cursor: "pointer",
    boxShadow: `0px 0px 0.25rem ${colors.shadow_black}`,
    ":hover": {
      boxShadow: `0 0 0.75rem ${colors.shadow_black}`,
    },
    transition: "all 0.25s ease",
  },
  refreshIcon: {
    rotate: "45deg",
    color: colors.border_gray,
    py: "0.25rem",
  },
  downloadButton: {
    color: colors.download_button_text,
    borderColor: colors.download_button_text,
    fontSize: "0.875 rem",
    fontWeight: 400,
    px: "0.75 rem",
    py: "0.25 rem",
  },
  tableMarginTop: {
    mt: "1.5rem",
  },
  paginationMarginTop: {
    mt: "-0.5rem",
  },
  downloadIcon: {
    height: "1.0rem",
    width: "1.0rem",
  },
  emptyStateRow: { height: "48vh" },
  emptyStateText: { textAlign: "center" },
  nameCell: { minWidth: "14.0rem" },

  textFieldStyle: (
    isOpen: boolean,
    value: any,
    getBorderColor: any,
    getSectionColor: any
  ): SxProps => ({
    width: "100%",
    maxWidth: "100%",
    ...(isOpen
      ? {
          "& fieldset": {
            borderColor: `${colors.filter_red} !important`,
            borderWidth: "1px !important",
          },
          "&:hover fieldset": {
            borderColor: `${colors.filter_red} !important`,
          },
        }
      : {
          "& fieldset": {
            borderColor: `${colors.border_gray_color} !important`,
            borderWidth: "1px !important",
          },
          "&:hover fieldset": {
            borderColor: `${colors.black} !important`,
          },
        }),

    "& .MuiPickersInputBase-root": {
      cursor: "pointer",
      paddingRight: "0.5rem",
    },

    "& .MuiPickersSectionList-root": {
      color: getSectionColor(value),
      opacity: value ? 1 : 0.6,
    },
    "& .MuiPickersInputBase-sectionsContainer": {
      color: getSectionColor(value),
      opacity: value ? 1 : 0.6,
    },
    "& .MuiPickersOutlinedInput-sectionsContainer": {
      color: getSectionColor(value),
      opacity: value ? 1 : 0.6,
    },

    "& .MuiOutlinedInput-root": {
      height: "2.5rem",

      "& fieldset": {
        borderColor: `${getBorderColor(isOpen)} !important`,
      },
      "&:hover fieldset": {
        borderColor: `${
          isOpen ? getBorderColor(isOpen) : colors.black
        } !important`,
      },

      "&.Mui-focused": {
        "& fieldset": {
          borderColor: `${getBorderColor(isOpen)} !important`,
        },
      },

      "&.Mui-focused fieldset": {
        borderColor: `${getBorderColor(isOpen)} !important`,
      },
    },
  }),
  errorSnackbar: {
    width: "100%",
  },
};
